import { Section } from '@/components/shared';
import { Box, Flex } from '@chakra-ui/react';
import { useKeenSlider } from 'keen-slider/react';
import React from 'react';
import { useTrackCurrentSlide, useTrackLoadedState } from '../hooks';
import { CollabLogo } from './CollabLogo';
import { SlideDots } from './SlideDots';
import { collabItems } from '../constants';
import { useTranslation } from 'react-i18next';

export const Collabs: React.FC = (): JSX.Element => {
  const [currentSlide, setCurrentSlide] = useTrackCurrentSlide();
  const [isLoaded, setLoaded] = useTrackLoadedState();
  const { t } = useTranslation();

  const [sliderRef, instanceRef] = useKeenSlider<HTMLDivElement>({
    initial: 0,
    disabled: false,
    mode: 'free-snap',
    slides: {
      perView: 2,
    },
    breakpoints: {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      '(min-width: 48em)': {
        disabled: true,
      },
    },
    slideChanged(slider) {
      setCurrentSlide(slider.track.details.rel);
    },
    created() {
      setLoaded(true);
    },
  });

  return (
    <Section id="collabs" title={t('LANDING.COLLABS.SECTION_TITLE')}>
      <Flex
        alignItems="center"
        className="keen-slider"
        flexWrap={{ base: 'nowrap', md: 'wrap' }}
        gap={{ base: 2, md: 8 }}
        justifyContent={{ base: 'normal', md: 'center' }}
        ref={sliderRef}
      >
        {collabItems.map((item) => {
          return (
            <Box
              className="keen-slider__slide"
              h="100"
              key={item.id}
              my={8}
              shadow="xl"
              w={{ base: 'full', md: '200px' }}
            >
              <CollabLogo image={item.image} imageHover={item.imageHover} url={item.url} />
            </Box>
          );
        })}
      </Flex>
      {isLoaded && instanceRef.current && (
        <SlideDots currentSlide={currentSlide} slider={instanceRef} />
      )}
    </Section>
  );
};
